import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'base',
        component: () => import('@/pages/index')
    },
    {
        path: '/misnegocios',
        name: 'misnegocios',
        component: () => import('../views/Negocios/manage'),
        children: [
            {
                path: 'registro',
                name: 'misnegocios.registro',
                component: () => import('../views/Negocios/registro')
            }
        ]
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/Dashboard/Layout'),
        children: [
            {
                path: 'indicators',
                name: 'dashboard.indicators',
                component: () => import('../views/Dashboard/Indicators')
            },
            {
                path: 'backup',
                name: 'dashboard.backup',
                component: () => import('../views/Dashboard/Backup')
            },
            {
                path: 'logs',
                name: 'dashboard.logs',
                component: () => import('../views/Dashboard/Logs')
            }
        ]
    },
    {
        path: '/catalogo',
        name: 'catalogo',
        component: () => import('../pages/Catalogo/Layout'),
        children: [
            {
                path: 'resumen',
                name: 'catalogo.resumen',
                component: () => import('../pages/Catalogo/Resumen')
            },
            {
                path: 'promociones',
                name: 'promociones',
                component: () => import('../pages/Catalogo/Promociones')
            },
            {
                path: 'productos',
                name: 'productos',
                component: () => import('../pages/Catalogo/Productos')
            },
            {
                path: 'servicios',
                name: 'servicios',
                component: () => import('../pages/Catalogo/Servicios')
            },
            {
                path: 'categorias',
                name: 'categorias',
                component: () => import('../pages/Catalogo/Categorias')
            }
        ]
    },
    {
        path: '/tienda',
        name: 'tienda',
        component: () => import('../pages/Tienda/Layout'),
        children: [
            {
                path: 'resumen',
                name: 'tienda.resumen',
                component: () => import('../pages/Tienda/Resumen')
            },
            {
                path: 'productos',
                name: 'tienda.productos',
                component: () => import('../pages/Tienda/Productos')
            },
            {
                path: 'ventas',
                name: 'ventas',
                component: () => import('../pages/Tienda/Ventas')
            }
        ]
    },
    {
        path: '/pagoenlinea',
        name: 'pagoenlinea',
        component: () => import('../pages/PagoEnLinea/Layout'),
        children: [
            {
                path: 'activar',
                name: 'activar',
                component: () => import('../pages/PagoEnLinea/Activar')
            },
            {
                path: 'resumen',
                name: 'pagoenlinea.resumen',
                component: () => import('../pages/PagoEnLinea/Resumen')
            },
            {
                path: 'configuracion',
                name: 'pagoenlinea.configuracion',
                component: () => import('../pages/PagoEnLinea/Configuracion')
            },
            {
                path: 'pagos',
                name: 'pagoenlinea.pagos',
                component: () => import('../pages/PagoEnLinea/Pagos')
            },
            {
                path: 'depositos',
                name: 'pagoenlinea.depositos',
                component: () => import('../pages/PagoEnLinea/Depositos')
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
// router.beforeEach((to, from, next) => {
//     console.dir(to)
//   if (!to.params.negocio) {
//       next('/misnegocios')
//   }
// })
export default router